import axios from "axios";
import { URLS } from "./URLS";
import Store from "../Stores/Store";

export default async function getBalance(id) {
  let param = null;
  if (Store.payment.accounts.id_unified_account) {
    param = "unified_id";
  } else {
    param = "id_pa";
  }
  let data = {};
  await axios(`${URLS.url}/saldo_info?${param}=${id}`)
    .then((res) => {
      data = res.data;
    })
    .catch(function (error) {
      data = "error";
    });
  return data;
}
